const { isEmpty } = require('lodash');

module.exports = {
  fields: {
    name: {
      type: 'string',
      label: 'タグ名',
      validations: {
        required: v => !isEmpty(v),
      },
    },
  },
};
